module.exports = __webpack_public_path__ + "static/media/text-search.08b3a081.svg";